/* eslint-disable prettier/prettier */
import { FC } from 'react';
import styles from '../../styles/components/controlVariations/AuthInfoCard.module.css';

interface AuthInfoCardProps {
	title: string;
	description1: string;
	description2: string;
	iconSrc?: string;
	iconAlt?: string;

	// ✅ NEW PROPS (added only)
	showButton?: boolean;
	buttonText?: string;
	onButtonClick?: () => void;
}

const AuthInfoCard: FC<AuthInfoCardProps> = ({
	title,
	description1,
	description2,
	iconSrc,
	iconAlt = 'status icon',

	// ✅ NEW PROPS
	showButton = false,
	buttonText = 'Let’s get started',
	onButtonClick,
}) => {
	return (
		<div className={`${styles.card} ${!showButton ? styles.autoFade : ''}`}>
			{iconSrc && (
				<div className={styles.iconWrapper}>
					<img src={iconSrc} alt={iconAlt} className={styles.icon} />
				</div>
			)}

			<div className={styles.cont}>
				<h2 className={styles.title}>{title}</h2>

				<p className={styles.description}>{description1}</p>
				<p className={styles.description}>{description2}</p>

				{/* ✅ Button INSIDE description area */}
				{showButton && (
					<button
						className={styles.ctaButton}
						onClick={onButtonClick}
					>
						{buttonText}
					</button>
				)}
			</div>
		</div>
	);
};

export default AuthInfoCard;
